<form
  [formGroup]="form"
  class="add-card">
  <h2 class="headline">{{ 'SAVED_CARD_PAGE.MODAL_ADD.TITLE' | translate }}</h2>
  <div class="scroll-block">
    <div class="add-card__line">

      <div
        [class.error]="form.get('cardNumber')?.invalid && form.get('cardNumber')?.touched"
        class="input-block">
        <input
          formControlName="cardNumber"
          id="cardNumber"
          class="input"
          type="text"
          mask="0000 0000 0000 0000"
          inputmode="numeric"
          placeholder=" ">
        <label
          for="cardNumber"
          class="placeholder">
          {{ 'SAVED_CARD_PAGE.MODAL_ADD.CARD_NUMBER' | translate }}
        </label>
        <ng-container *ngIf="form.get('cardNumber')?.invalid && form.get('cardNumber')?.touched">
          <span
            *ngIf="cardNumberFormatError"
            class="input-block__error">
            {{ 'SAVED_CARD_PAGE.MODAL_ADD.CARD_NUMBER_FORMAT_ERROR' | translate }}
          </span>
          <span
            *ngIf="cardNumberRequiredError"
            class="input-block__error">
            {{ 'SAVED_CARD_PAGE.MODAL_ADD.CARD_NUMBER_REQUIRED' | translate }}
          </span>
        </ng-container>
      </div>
    </div>
    <div class="card-data">
      <div class="add-card__line date">
        <p class="input-line__name">{{ 'SAVED_CARD_PAGE.MODAL_ADD.DATE_CARD' | translate }}</p>
        <div
          [class.error]="form.get('mount')?.invalid && form.get('mount')?.touched"
          class="input-block">
          <input
            formControlName="mount"
            id="mount"
            class="input"
            type="text"
            mask="00"
            inputmode="numeric"
            placeholder="{{'SAVED_CARD_PAGE.MODAL_ADD.CARD_MOUNT' | translate}}">
          <ng-container *ngIf="form.get('mount')?.invalid && form.get('mount')?.touched">
            <span
              *ngIf="mountFormatError"
              class="input-block__error">
              {{ 'SAVED_CARD_PAGE.MODAL_ADD.MOUNT_FORMAT_ERROR' | translate }}
            </span>
            <span
              *ngIf="mountMinError"
              class="input-block__error">
              {{ 'SAVED_CARD_PAGE.MODAL_ADD.MOUNT_MIN_ERROR' | translate }}
            </span>
            <span
              *ngIf="mountRequiredError"
              class="input-block__error">
              {{ 'SAVED_CARD_PAGE.MODAL_ADD.MOUNT_REQUIRED' | translate }}
            </span>
          </ng-container>
        </div>

        <div
          [class.error]="form.get('year')?.invalid && form.get('year')?.touched"
          class="input-block">
          <input
            formControlName="year"
            id="year"
            class="input"
            type="text"
            mask="00"
            inputmode="numeric"
            placeholder="{{'SAVED_CARD_PAGE.MODAL_ADD.CARD_YEAR' | translate}}">
          <ng-container *ngIf="form.get('year')?.invalid && form.get('year')?.touched">
             <span
               *ngIf="yearFormatError"
               class="input-block__error">
              {{ 'SAVED_CARD_PAGE.MODAL_ADD.YEAR_FORMAT_ERROR' | translate }}
            </span>
            <span
              *ngIf="yearRequiredError"
              class="input-block__error">
              {{ 'SAVED_CARD_PAGE.MODAL_ADD.YEAR_REQUIRED' | translate }}
            </span>
          </ng-container>
        </div>
      </div>

      <div class="add-card__line cvv">
        <p class="input-line__name">{{'SAVED_CARD_PAGE.MODAL_ADD.CVV' | translate}}</p>
        <div
          [class.error]="form.get('cvv')?.invalid && form.get('cvv')?.touched"
          class="input-block">
          <input
            formControlName="cvv"
            id="cvv"
            class="input"
            type="text"
            mask="000"
            inputmode="numeric"
            placeholder="***">
          <ng-container *ngIf="form.get('cvv')?.invalid && form.get('cvv')?.touched">
            <span
              *ngIf="cvvFormatError"
              class="input-block__error">
              {{ 'SAVED_CARD_PAGE.MODAL_ADD.CVV_FORMAT_ERROR' | translate }}
            </span>
            <span
              *ngIf="cvvRequiredError"
              class="input-block__error">
              {{ 'SAVED_CARD_PAGE.MODAL_ADD.CVV_REQUIRED' | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="add-card__line">
      <div
        [class.error]="form.get('cardHolderName')?.invalid && form.get('cardHolderName')?.touched"
        class="input-block">
        <input
          formControlName="cardHolderName"
          id="cardHolderName"
          class="input"
          type="text"
          inputmode="numeric"
          placeholder=" ">
        <label
          for="cardHolderName"
          class="placeholder">
          {{ 'SAVED_CARD_PAGE.MODAL_ADD.CARD_HOLDER_NAME' | translate }}
        </label>
        <ng-container *ngIf="form.get('cardHolderName')?.invalid && form.get('cardHolderName')?.touched">
          <span
            *ngIf="!cardHolderNameRequiredError && cardHolderNameFormatError"
            class="input-block__error">
            {{ 'SAVED_CARD_PAGE.MODAL_ADD.CARD_HOLDER_FORMAT_ERROR' | translate }}
          </span>
          <span
            *ngIf="cardHolderNameRequiredError"
            class="input-block__error">
            {{ 'SAVED_CARD_PAGE.MODAL_ADD.CARD_HOLDER_REQUIRED' | translate }}
          </span>
        </ng-container>
      </div>
    </div>

    <div class="add-card__line color-set">
      <div class="input-line">
        <p class="input-line__name">{{ 'SAVED_CARD_PAGE.MODAL_ADD.SET_COLOR' | translate }}</p>
        <div class="btn-block">
          <button
            *ngFor="let item of buttonsColor"
            [style]="{backgroundColor: item.color}"
            [class.active]="item.color === selectedColor"
            (click)="selectColor(item.color)"
            class="color-select">
          </button>
        </div>
      </div>
    </div>

    <div class="add-card__line block">
      <p class="add-card__line-description">{{ 'SAVED_CARD_PAGE.MODAL_ADD.DESCRIPTION_1' | translate }}
        <span>140 ₸</span></p>
      <p class="add-card__line-description">{{ 'SAVED_CARD_PAGE.MODAL_ADD.DESCRIPTION_2' | translate }}</p>
    </div>
  </div>


  <div class="btn-block">
    <button
      [disabled]="this.form.invalid || isSending || !this.selectedColor"
      (click)="createCard()"
      class="btn btn-accent">
      {{ 'SAVED_CARD_PAGE.MODAL_ADD.SAVE' | translate }}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{ 'SAVED_CARD_PAGE.MODAL_ADD.CANCEL' | translate }}
    </button>
  </div>

</form>

